import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, ListChecks, Users2, Search, Menu } from "lucide-react";

const ITEMS = [
  { to: "/dashboard", label: "Home", icon: Home, tid: "home" },
  { to: "/taken", zoek: "?tab=mijn", label: "Taken", icon: ListChecks, tid: "taken" },
  { to: "/vaste-klanten", label: "Vaste klanten", icon: Users2, tid: "vaste-klanten" },
];

const zoekFocus = () => {
  const veld = document.querySelector("[data-testid='v3-zoek-veld']");
  if (veld) { veld.focus(); veld.scrollIntoView({ block: "nearest" }); } else window.dispatchEvent(new Event("bpt:open-cmdk"));
};

/** Layout v3 telefoon: vast menu onderaan — Home, Taken, Vaste klanten, Zoeken, Meer (alle onderdelen). */
export function V3BottomNav({ hubs, meerOpen, onMeer }) {
  const { pathname } = useLocation();
  const paden = new Set(hubs.flatMap((h) => h.items.map((it) => it.to.split("?")[0])));
  const items = ITEMS.filter((it) => it.to === "/dashboard" || paden.has(it.to));
  return (
    <nav className="v3-bnav" aria-label="Snelmenu" data-testid="v3-bnav">
      {items.map((it) => {
        const Icon = it.icon;
        const actief = !meerOpen && (pathname === it.to || pathname.startsWith(`${it.to}/`));
        return (
          <NavLink key={it.tid} to={it.to + (it.zoek || "")} className={`v3-bn${actief ? " on" : ""}`} aria-current={actief ? "page" : undefined}
            onClick={() => meerOpen && onMeer(false)} data-testid={`v3-bnav-${it.tid}`}>
            <Icon /><span>{it.label}</span>
          </NavLink>
        );
      })}
      <button type="button" className="v3-bn" onClick={() => { onMeer(false); zoekFocus(); }} data-testid="v3-bnav-zoeken"><Search /><span>Zoeken</span></button>
      <button type="button" className={`v3-bn${meerOpen ? " on" : ""}`} onClick={() => onMeer(!meerOpen)} aria-expanded={meerOpen} data-testid="v3-bnav-meer"><Menu /><span>Meer</span></button>
    </nav>
  );
}
